import { render, staticRenderFns } from "./edit-obj.vue?vue&type=template&id=24ef8e66&scoped=true&"
import script from "./edit-obj.vue?vue&type=script&lang=js&"
export * from "./edit-obj.vue?vue&type=script&lang=js&"
import style0 from "./edit-obj.vue?vue&type=style&index=0&id=24ef8e66&prod&lang=scss&"
import style1 from "./edit-obj.vue?vue&type=style&index=1&id=24ef8e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef8e66",
  null
  
)

export default component.exports